import React from 'react'

import { Box } from '@mui/material'
import { TableHeader, TableRow, FormTable } from '@front/squirtle'

import Popup from './Popup'
import HeaderSection from './Form'
import Header from './Header'
import Row from './Row'

const ListDetails = ({ onRowClick, list_id, task }) =>
  <Box sx={{ m: 5 }}>
    <Popup />
    <HeaderSection task={task} />
    <FormTable
      model_name={'order'}
      config={{
        search_id: 'list_orders',
        populate: ['commercial_package', 'source', 'destination', 'do.info', 'do.customerinfo', 'service.contract.company'],
        initial_filter: { list: list_id },
        forced_filter: { list: list_id },
        watch_type: 'result'
      }}
      submitOnMount
      tableProps={{
        submitOnMount: true,
        enableRowActions: true,
        allowEditMode: false,
        allowRowGenerate: false,
        onRowClick
      }}
    >
      <TableHeader><Header /></TableHeader>
      <TableRow><Row /></TableRow>
    </FormTable>
  </Box>


export default React.memo(ListDetails)
